var map = {
	"./gold1.webp": [
		2677
	],
	"./gold2.webp": [
		8595
	],
	"./gold3.webp": [
		1948
	],
	"./gold4.webp": [
		3870
	],
	"./gold5.webp": [
		8627
	],
	"./gold6.webp": [
		5994,
		994
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2345;
module.exports = webpackAsyncContext;